import { authedEndpoint } from "../../../builder";

export const list = authedEndpoint.query(() => ({
    url: "export-settings/additional-formats",
}));
